import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Compact image carousel for catalog items. Shows single or multiple images
 * with subtle navigation arrows and dot indicators.
 */
const ItemImageCarousel = ({ images, alt, aspectClass = 'aspect-video' }) => {
  const [idx, setIdx] = useState(0);
  const list = (images && images.length > 0) ? images : [];

  if (list.length === 0) {
    return (
      <div className={`${aspectClass} bg-surface-light flex items-center justify-center`}>
        <span className="text-xs text-text-muted font-body">Aucune image</span>
      </div>
    );
  }

  const prev = (e) => {
    e.stopPropagation();
    setIdx((p) => (p - 1 + list.length) % list.length);
  };
  const next = (e) => {
    e.stopPropagation();
    setIdx((p) => (p + 1) % list.length);
  };

  return (
    <div className={`relative ${aspectClass} overflow-hidden group bg-surface-light`}>
      <img
        src={list[idx]}
        alt={alt}
        className="w-full h-full object-cover transition-opacity duration-500"
      />
      {list.length > 1 && (
        <>
          <button
            onClick={prev}
            className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-1.5 opacity-0 group-hover:opacity-100 transition-opacity"
            aria-label="Previous"
          >
            <ChevronLeft className="w-4 h-4 text-text-primary" />
          </button>
          <button
            onClick={next}
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-1.5 opacity-0 group-hover:opacity-100 transition-opacity"
            aria-label="Next"
          >
            <ChevronRight className="w-4 h-4 text-text-primary" />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
            {list.map((_, i) => (
              <button
                key={i}
                onClick={(e) => { e.stopPropagation(); setIdx(i); }}
                className={`w-1.5 h-1.5 rounded-full transition-all ${
                  i === idx ? 'bg-white w-4' : 'bg-white/60'
                }`}
                aria-label={`Image ${i + 1}`}
              />
            ))}
          </div>
          <span className="absolute top-2 right-2 bg-black/60 text-white text-xs px-2 py-0.5 font-body">
            {idx + 1}/{list.length}
          </span>
        </>
      )}
    </div>
  );
};

export default ItemImageCarousel;
